import "../assets/Steps.css";
import { h as Ce, defineComponent as R, ref as S, computed as l, onMounted as Y, openBlock as f, createElementBlock as b, normalizeStyle as A, createVNode as M, Fragment as O, renderList as Q, normalizeClass as ce, unref as p, createCommentVNode as Z, createElementVNode as m, inject as Ae, watchEffect as ge, onBeforeUnmount as Me, toDisplayString as V, defineAsyncComponent as Re, createBlock as me, mergeProps as j, toRaw as xe, useCssVars as we, isRef as de, withKeys as pe, withModifiers as ve, renderSlot as De, nextTick as Fe, withCtx as Le, createTextVNode as He, watch as qe, Transition as Be, resolveDynamicComponent as Pe } from "vue";
import { e as C, A as X, T as $e, P as Ie, a as J, C as Ke, n as Ee, o as fe, q as ze, c as Ne, l as K, r as U, f as ae, b as ye } from "./maps.DxC18PqJ.js";
import { u as Oe } from "./index.AJuLibkw.js";
import { n as H, B as le, k as Ue, d as be } from "./useStore.CDG6wbfK.js";
import { a as ee, _ as Se, b as Ze, s as Ye } from "./Text.vue_vue_type_style_index_0_lang.CqNxQPnN.js";
import { _ as he } from "./Input.vue_vue_type_style_index_0_lang.CzaKyjSR.js";
import { _ as _e } from "./Terms.vue_vue_type_style_index_0_lang.DvSwaGI1.js";
import { _ as je } from "./Tooltip.vue_vue_type_style_index_0_lang.BZsawpJG.js";
import { _ as Ve } from "./_plugin-vue_export-helper.CHgC5LLL.js";
const We = (t, e) => {
  const a = "http://www.w3.org/2000/svg", c = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M4.166 5a8.25 8.25 0 1111.668 11.667A8.25 8.25 0 014.166 4.999zM10 4.082a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-.75 4.25a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zm-.833 2.5a.75.75 0 01.75-.75H10a.75.75 0 01.75.75v2.583h.083a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75v-2.583h-.083a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (t.title) {
    const y = document.createElementNS(a, "title");
    y.textContent = t.title, c.appendChild(y);
  }
  const h = Array.from((c == null ? void 0 : c.attributes) ?? []).reduce((y, s) => ({
    ...y,
    [s.name]: s.value
  }));
  return Ce(
    "svg",
    {
      ...h,
      ...e.attrs,
      role: "img",
      innerHTML: c.innerHTML
    }
  );
};
var ne = /* @__PURE__ */ ((t) => (t.Active = "active", t.Next = "next", t.Previous = "previous", t))(ne || {});
const Ge = ["data-module-id"], ke = /* @__PURE__ */ R({
  __name: "EmailCapture",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = {
      [C.SavedSearch]: X.SendSaveSearch,
      [C.EmailCapture]: X.SendSubscribe
    }, a = H(), i = t, c = S(), h = S(null), y = S(""), s = l(() => {
      var o;
      return ((o = a == null ? void 0 : a.extraData.defaultAssets) == null ? void 0 : o.terms) || [];
    }), T = l(() => i.moduleProps.terms.customTerms), w = l(() => i.moduleProps.terms.isTermRequired), L = l(
      () => i.moduleProps.terms.isTermsInheritedFromProperty
    ), r = l(() => a == null ? void 0 : a.literals.getLiteral("Please, provide a valid e-mail")), g = l(() => a == null ? void 0 : a.literals.getLiteral("Your email")), n = l(() => (a == null ? void 0 : a.handlers.buttonState) === le.Sending), d = l(() => ee(i.moduleProps.appearance, a == null ? void 0 : a.device));
    function v() {
      if (c.value && h.value && c.value.validate()) {
        const _ = h.value.validate();
        if (_.valid)
          return {
            emailAddress: y.value,
            terms: _.terms
          };
      }
      return !1;
    }
    return Y(() => {
      a == null || a.handlers.setDataValidator(e[i.moduleProps.moduleType], v);
    }), (o, _) => (f(), b("div", {
      class: "thn--tool-emailcapture",
      "data-module-id": o.moduleProps.id,
      style: A(d.value)
    }, [
      M(he, {
        class: "thn--tool-emailcapture__input",
        ref_key: "emailRef",
        ref: c,
        type: "email",
        modelValue: y.value,
        "onUpdate:modelValue": _[0] || (_[0] = (P) => y.value = P),
        placeholder: g.value,
        "error-message": r.value,
        disabled: !!n.value,
        required: !0
      }, null, 8, ["modelValue", "placeholder", "error-message", "disabled"]),
      M(_e, {
        class: "thn--tool-emailcapture__terms",
        ref_key: "termsRef",
        ref: h,
        disabled: !!n.value,
        "custom-terms": T.value,
        "property-terms": s.value,
        "terms-inherited": L.value,
        "terms-required": w.value,
        "appearance-style": d.value
      }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
    ], 12, Ge));
  }
}), Je = ["data-module-id"], Qe = {
  key: 0,
  class: "thn--tool-perks__bullet"
}, Xe = { class: "thn--tool-perks__label" }, et = ["innerHTML"], tt = ["onMouseover", "onMouseout"], at = /* @__PURE__ */ R({
  __name: "Perks",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = H(), a = t, i = S({}), c = l(() => {
      var g;
      return ((g = e == null ? void 0 : e.styles.fonts.perks) == null ? void 0 : g.textTransform) === $e.Titlecase;
    }), h = l(() => ee(a.moduleProps.appearance, e == null ? void 0 : e.device)), y = l(() => a.moduleProps.isPerksInheritedFromProperty), s = l(() => {
      var r;
      return y.value ? (r = e == null ? void 0 : e.extraData.defaultAssets) == null ? void 0 : r.perks : a.moduleProps.perks;
    });
    function T(r, g) {
      var P;
      const n = (P = s.value) == null ? void 0 : P.find(($) => $.perkId === g), d = n && n.perk.tooltipInfo && (e == null ? void 0 : e.literals.getPerkTooltipLiteral(n.perk.tooltipInfo)), {
        left: v,
        top: o,
        width: _
      } = r.getBoundingClientRect();
      i.value[g].show(d, {
        left: v + _ / 2,
        top: o
      });
    }
    function w(r) {
      return e && r.description ? e.literals.getPerkActiveLiteral(r.description, c.value) : r.name;
    }
    function L(r) {
      i.value[r].hide();
    }
    return (r, g) => (f(), b("div", {
      class: "thn--tool-perks",
      "data-module-id": r.moduleProps.id,
      style: A(h.value)
    }, [
      (f(!0), b(O, null, Q(s.value, ({ perkId: n, perk: d }) => {
        var v, o;
        return f(), b("div", {
          class: ce({
            "thn--tool-perks__perk": !0,
            highlights: ((v = r.moduleProps.appearance) == null ? void 0 : v.layout) === "highlights"
          }),
          key: n
        }, [
          ((o = r.moduleProps.appearance) == null ? void 0 : o.layout) === p(Ie).Bullets ? (f(), b("div", Qe)) : Z("", !0),
          m("div", Xe, [
            m("span", {
              class: "thn--tool-perks__label-text",
              innerHTML: w(d)
            }, null, 8, et),
            d.tooltipInfo ? (f(), b("div", {
              key: 0,
              class: "thn--tool-perks__icon",
              onMouseover: (_) => T(_.target, n),
              onMouseout: () => L(n)
            }, [
              M(p(We)),
              M(je, {
                class: "thn--tool-perks__tooltip",
                ref_for: !0,
                ref: (_) => i.value[n] = _,
                "back-color": "#ffffff",
                color: "#000000"
              }, null, 512)
            ], 40, tt)) : Z("", !0)
          ])
        ], 2);
      }), 128))
    ], 12, Je));
  }
}), nt = ["data-module-id", "data-style", "data-size"], lt = { class: "thn--tool-countdown__number" }, ot = { class: "thn--tool-countdown__label" }, st = ["title"], it = { key: 1 }, rt = /* @__PURE__ */ R({
  __name: "Countdown",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = H(), a = t, c = S({
      hours: "00",
      minutes: "00",
      seconds: "00"
    }), h = S(!0), y = S(), s = S(!1), T = Ae("layout"), w = l(() => {
      var r, g;
      return ((r = a.moduleProps.appearance) == null ? void 0 : r.size) === "compact" && ((g = T == null ? void 0 : T.value) == null ? void 0 : g.type) === J.StickyImage;
    });
    ge(() => {
      const {
        type: r,
        details: g
      } = a.moduleProps, n = e != null && e.extraData.countdownTimestamp ? e == null ? void 0 : e.extraData.countdownTimestamp : (e == null ? void 0 : e.extraData.getCountdownTimestamp(r, g)) || Date.now(), {
        builderMode: d = !1,
        countdownInitTime: v = Date.now()
      } = (e == null ? void 0 : e.extraData) || {};
      s.value = d && r === Ke.Time, y.value = s.value ? n - v : n;
    });
    function L() {
      if (!h.value) {
        const r = Math.round((y.value - (s.value ? 0 : Date.now())) / 1e3), g = Ue(r);
        r > 0 ? (c.value = g, setTimeout(L, 200)) : c.value = g;
      }
    }
    return ge(L), Y(() => {
      h.value = !1;
    }), Me(() => {
      h.value = !0;
    }), (r, g) => {
      var n, d;
      return f(), b("div", {
        class: "thn--tool-countdown",
        "data-module-id": r.moduleProps.id,
        "data-style": (n = r.moduleProps.appearance) == null ? void 0 : n.style,
        "data-size": (d = r.moduleProps.appearance) == null ? void 0 : d.size
      }, [
        (f(!0), b(O, null, Q(c.value, (v, o) => {
          var _, P, $;
          return f(), b("div", {
            class: "thn--tool-countdown__block",
            key: o
          }, [
            m("div", lt, V(v), 1),
            m("div", ot, [
              w.value ? (f(), b("abbr", {
                key: 0,
                title: (_ = p(e)) == null ? void 0 : _.literals.getLiteral(o)
              }, V((P = p(e)) == null ? void 0 : P.literals.getLiteralAbb(o)), 9, st)) : (f(), b("span", it, V(($ = p(e)) == null ? void 0 : $.literals.getLiteral(o)), 1))
            ])
          ]);
        }), 128))
      ], 8, nt);
    };
  }
}), ut = ["data-module-id"], dt = /* @__PURE__ */ R({
  __name: "Form",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = H(), a = t, i = S(null), c = S(), h = Re(
      // @ts-ignore the lack of TS definitions for this package
      () => import("./form-viewer.common.BPhVNMMF.js").then((o) => o.f)
    ), y = l(() => (e == null ? void 0 : e.handlers.buttonState) === le.Sending), s = l(() => {
      var o;
      return (o = e == null ? void 0 : e.extraData.defaultAssets) == null ? void 0 : o.terms;
    }), T = l(() => a.moduleProps.terms.customTerms), w = l(() => a.moduleProps.terms.isTermRequired), L = l(
      () => a.moduleProps.terms.isTermsInheritedFromProperty
    ), r = S([]), g = l(() => ee(a.moduleProps.appearance, e == null ? void 0 : e.device)), n = (o) => {
      r.value = o.values;
    }, d = l(() => {
      const {
        name: o,
        fields: _,
        fieldsPosition: P
      } = a.moduleProps, $ = P === Ee.Out ? 1 : 2;
      return {
        lang: e == null ? void 0 : e.language,
        data: {
          name: o,
          fields: _.map((E) => {
            const {
              id: z,
              type: q,
              labels: I,
              hiddenName: x,
              optional: u,
              options: k = [],
              selection: D = fe.Single,
              defaultOption: oe,
              popupPosition: se
            } = E, ie = k.map((W) => ({
              value: W.id,
              label: W.labels
            })), N = D === fe.Multiple ? "multiSelection" : "oneSelection";
            return {
              type: q === ze.Selection ? N : q,
              default: oe,
              label: I,
              labelDisplay: x ? 0 : $,
              name: z,
              required: !u,
              options: ie,
              popupPosition: se
            };
          })
        }
      };
    });
    async function v() {
      if (c.value && i.value && (await c.value.formRef.validate()).valid) {
        const _ = i.value.validate();
        if (_.valid)
          return {
            formFields: xe(r.value),
            terms: _.terms
          };
      }
      return !1;
    }
    return Y(() => {
      e == null || e.handlers.setDataValidator(X.SendForm, v);
    }), (o, _) => (f(), b("div", {
      class: "thn--tool-form",
      style: A(g.value),
      "data-module-id": o.moduleProps.id
    }, [
      d.value ? (f(), me(p(h), j({
        key: 0,
        class: "thn--tool-form__viewer",
        ref_key: "viewerRef",
        ref: c
      }, d.value, { onChange: n }), null, 16)) : Z("", !0),
      M(_e, {
        class: "thn--tool-form__terms",
        ref_key: "termsRef",
        ref: i,
        disabled: !!y.value,
        "custom-terms": T.value,
        "property-terms": s.value,
        "terms-inherited": L.value,
        "terms-required": w.value,
        "appearance-style": g.value
      }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
    ], 12, ut));
  }
}), ct = ["data-module-id"], mt = /* @__PURE__ */ R({
  __name: "Spacer",
  props: {
    moduleProps: {}
  },
  setup(t) {
    we((c) => ({
      "085015d8": a.value,
      a6b4a6ac: i.value
    }));
    const e = t, a = l(() => {
      var c;
      return `${((c = e.moduleProps.desktop) == null ? void 0 : c.space) || 0}px`;
    }), i = l(() => {
      var c;
      return `${((c = e.moduleProps.mobile) == null ? void 0 : c.space) || 0}px`;
    });
    return (c, h) => (f(), b("div", {
      "data-module-id": c.moduleProps.id,
      class: "thn--tool-spacer"
    }, null, 8, ct));
  }
}), pt = S(!1), F = S(), vt = S(""), Te = S(""), re = S(!1), ue = S(!1), te = () => {
  const t = H(), e = S((/* @__PURE__ */ new Date()).getTime().toString()), a = t == null ? void 0 : t.literals.getLiteral("Invalid code"), i = l(() => (t == null ? void 0 : t.language) || "en"), c = l(() => {
    var u;
    return ee((u = F.value) == null ? void 0 : u.appearance, t == null ? void 0 : t.device);
  }), h = l(() => {
    const u = {
      label: t == null ? void 0 : t.literals.getLiteral("Privacy policy"),
      url: `https://www.thehotelsnetwork.com/${i.value}/instant-privacy-policy`
    };
    return `
      ${t == null ? void 0 : t.literals.getLiteral("I agree to the")} 
      <a href="${u.url}" target="_blank">${u.label}</a>
    `;
  }), y = l(() => {
    var u;
    return (u = t == null ? void 0 : t.extraData.defaultAssets) == null ? void 0 : u.terms;
  }), s = l(
    () => {
      var u, k;
      return (k = (u = F.value) == null ? void 0 : u.terms) == null ? void 0 : k.isTermsInheritedFromProperty;
    }
  ), T = l(() => {
    var u, k;
    return [
      {
        termId: "instant-login-terms",
        isRequired: !0,
        term: {
          id: "instant-login-terms",
          name: "Instant Login Terms",
          isRequired: !0,
          content: {
            linkedTo: Ne.CustomUrl,
            htmlContent: h.value
          },
          properties: []
        }
      },
      ...((k = (u = F.value) == null ? void 0 : u.terms) == null ? void 0 : k.customTerms) || []
    ];
  }), w = l(() => {
    var u, k;
    return !!((k = (u = F.value) == null ? void 0 : u.terms) != null && k.isTermRequired);
  });
  let L;
  const r = l(() => {
    var u, k;
    return (u = F.value) != null && u.buttonModule && (L = (k = F.value) == null ? void 0 : k.buttonModule), L;
  }), g = l(() => {
    var u;
    return (u = r.value) == null ? void 0 : u.appearance;
  }), n = l(() => {
    var u;
    return ee((u = r.value) == null ? void 0 : u.appearance, t == null ? void 0 : t.device);
  }), d = S(K.LoginRegister), v = () => {
    Te.value = "", ue.value = !1, t == null || t.handlers.goBackToMainStep();
  }, o = (u) => {
    F.value = u, e.value = (/* @__PURE__ */ new Date()).getTime().toString(), d.value = u.currentView;
  }, _ = (u) => {
    F.value = {
      ...F.value,
      ...u
    };
  };
  function P() {
    t == null || t.handlers.setStepActive(K.LoginSignin, ae.Main);
  }
  function $() {
    v(), t == null || t.handlers.goBackToMainStep();
  }
  function E() {
    t == null || t.handlers.setStepActive(ae.Failure);
  }
  function z() {
    v(), t == null || t.handlers.setStepActive(K.LoginSuccess);
  }
  function q() {
    re.value = !0, ((t == null ? void 0 : t.handlers.stepActive) === K.LoginRegister || (t == null ? void 0 : t.handlers.stepActive) === ae.Main) && (v(), P());
  }
  const I = {
    [U.Signup]: $,
    [U.Validation]: q
  };
  return {
    sending: pt,
    sessionId: e,
    emailValue: vt,
    currentStep: d,
    moduleProps: F,
    authCodeValue: Te,
    validateError: a,
    showValidateError: ue,
    isAuthCodeRequested: re,
    termsArray: T,
    propertyTerms: y,
    isTermsRequired: w,
    buttonAppearance: g,
    buttonModule: r,
    buttonStyle: n,
    isTermsInheritedFromProperty: s,
    appearanceStyle: c,
    goToSignin: P,
    initModule: o,
    goToRegister: $,
    updateModule: _,
    doLoginAction: async (u) => {
      var D;
      if (!t) return;
      t.handlers.setDataValidator(X.Login, u);
      const k = await t.handlers.callHandler(
        X.Login,
        (D = F.value) == null ? void 0 : D.id
      );
      if (console.log("THN", "useLoginState", "doLoginAction", "result", k), !k || !k.ok) {
        t.handlers.stepActive === K.LoginSignin && re.value ? ue.value = !0 : E();
        return;
      }
      if (k.next) {
        I[k.next]();
        return;
      }
      z();
    }
  };
}, ht = { class: "thn--tool-register__form" }, _t = { class: "thn--tool-register__actions" }, gt = ["data-full-width"], ft = ["innerHTML"], yt = /* @__PURE__ */ R({
  __name: "Register",
  setup(t) {
    const e = H(), a = te(), {
      emailValue: i,
      isTermsRequired: c,
      termsArray: h,
      appearanceStyle: y,
      propertyTerms: s,
      buttonModule: T,
      buttonStyle: w,
      buttonAppearance: L,
      isTermsInheritedFromProperty: r,
      goToSignin: g,
      doLoginAction: n
    } = a, d = S(), v = S(null), o = l(() => (e == null ? void 0 : e.handlers.buttonState) === le.Sending || !1), _ = l(() => (e == null ? void 0 : e.literals.getLiteral("Please, provide a valid e-mail")) || ""), P = l(() => e == null ? void 0 : e.literals.getLiteral("Your email")), $ = l(() => e == null ? void 0 : e.literals.getLiteral("Already registered?")), E = l(() => e == null ? void 0 : e.literals.getLiteral("Sign in")), z = l(() => {
      var x;
      return !T.value || !(e != null && e.device) ? "" : e == null ? void 0 : e.literals.getActiveModuleText(
        T.value,
        ((x = e == null ? void 0 : e.styles.fonts[C.Button]) == null ? void 0 : x.textTransform) === $e.Titlecase
      );
    });
    function q() {
      if (d.value && v.value && d.value.validate()) {
        const u = v.value.validate();
        if (u.valid)
          return {
            action: U.Signup,
            emailAddress: i.value,
            terms: u.terms
          };
      }
      return !1;
    }
    async function I() {
      q() && n(q);
    }
    return (x, u) => {
      var k;
      return f(), b("div", j(x.$attrs, { class: "thn--tool-register" }), [
        m("div", ht, [
          M(he, {
            class: "thn--tool-register__input",
            ref_key: "emailRef",
            ref: d,
            type: "email",
            modelValue: p(i),
            "onUpdate:modelValue": u[0] || (u[0] = (D) => de(i) ? i.value = D : null),
            placeholder: P.value,
            "error-message": _.value,
            required: !0,
            style: A(p(y)),
            disabled: !!o.value
          }, null, 8, ["modelValue", "placeholder", "error-message", "style", "disabled"]),
          M(_e, {
            class: "thn--tool-register__terms",
            ref_key: "termsRef",
            ref: v,
            "property-terms": p(s),
            "terms-required": p(c),
            disabled: !!o.value,
            "custom-terms": p(h),
            "terms-inherited": !!p(r),
            style: A(p(y))
          }, null, 8, ["property-terms", "terms-required", "disabled", "custom-terms", "terms-inherited", "style"])
        ]),
        m("div", _t, [
          m("div", {
            role: "button",
            tabindex: "0",
            class: "thn--tool-button",
            style: A(p(w)),
            "data-full-width": (k = p(L)) == null ? void 0 : k.fullWidth,
            onClick: I,
            onKeyup: pe(I, ["enter"])
          }, [
            u[2] || (u[2] = m("div", { class: "thn--tool-button__back" }, null, -1)),
            m("div", {
              class: "thn--tool-button__label",
              innerHTML: z.value
            }, null, 8, ft)
          ], 44, gt),
          m("div", {
            class: "thn--tool-register__signin",
            style: A(p(y))
          }, [
            m("span", null, V($.value), 1),
            m("a", {
              href: "#",
              onClick: u[1] || (u[1] = ve(
                //@ts-ignore
                (...D) => p(g) && p(g)(...D),
                ["prevent", "stop"]
              ))
            }, V(E.value), 1)
          ], 4)
        ])
      ], 16);
    };
  }
}), bt = {};
function St(t, e) {
  return f(), b("svg", j({
    width: "8",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.$attrs), e[0] || (e[0] = [
    m("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.548 15.238a.381.381 0 0 0 .27-.65L1.23 8.001l6.587-6.588A.381.381 0 0 0 7.28.875L.42 7.732a.381.381 0 0 0 0 .538l6.858 6.858a.38.38 0 0 0 .27.11h-.001Z",
      fill: "currentColor"
    }, null, -1)
  ]), 16);
}
const kt = /* @__PURE__ */ Ve(bt, [["render", St]]), Tt = {};
function wt(t, e) {
  return f(), b("svg", j({
    width: "49",
    height: "48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.$attrs), e[0] || (e[0] = [
    m("rect", {
      x: ".5",
      width: "48",
      height: "48",
      rx: "24",
      fill: "#D9D9D9"
    }, null, -1),
    m("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.1 24.8a4.405 4.405 0 0 1-4.4-4.4c0-2.426 1.974-4.4 4.4-4.4s4.4 1.974 4.4 4.4-1.974 4.4-4.4 4.4Zm0-8a3.604 3.604 0 0 0-3.6 3.6c0 1.985 1.615 3.6 3.6 3.6s3.6-1.615 3.6-3.6-1.615-3.6-3.6-3.6ZM17.7 32c-.662 0-1.2-.538-1.2-1.2 0-.054.011-1.348.98-2.64.564-.752 1.336-1.35 2.295-1.775 1.171-.521 2.627-.785 4.325-.785 1.698 0 3.154.264 4.325.785.959.426 1.731 1.023 2.295 1.775.969 1.292.98 2.586.98 2.64 0 .662-.538 1.2-1.2 1.2H17.7Zm6.4-5.6c-2.79 0-4.848.762-5.953 2.205-.809 1.056-.845 2.135-.847 2.194v.003a.4.4 0 0 0 .4.398h12.8a.4.4 0 0 0 .4-.4c0-.01-.018-1.114-.847-2.195-1.106-1.443-3.164-2.205-5.953-2.205Z",
      fill: "#fff"
    }, null, -1)
  ]), 16);
}
const Lt = /* @__PURE__ */ Ve(Tt, [["render", wt]]), Pt = { class: "thn-tool--login__header-back" }, $t = { class: "thn-tool--login__header-back--user-icon" }, Vt = { class: "thn-tool--login__header-back--email" }, Ct = /* @__PURE__ */ R({
  __name: "HeaderBack",
  emits: ["goBack"],
  setup(t) {
    return (e, a) => (f(), b("div", Pt, [
      m("div", {
        role: "button",
        tabindex: "0",
        class: "thn-tool--login__header-back--button",
        onClick: a[0] || (a[0] = (i) => e.$emit("goBack")),
        onKeyup: a[1] || (a[1] = pe((i) => e.$emit("goBack"), ["enter"]))
      }, [
        M(kt)
      ], 32),
      m("div", $t, [
        M(Lt)
      ]),
      m("div", Vt, [
        De(e.$slots, "default")
      ])
    ]));
  }
}), At = {
  key: 0,
  class: "thn--tool-signin__auth-code"
}, Mt = { class: "thn--tool-signin__auth-code__container" }, Rt = ["onInput"], xt = {
  key: 0,
  class: "thn--tool-signin__auth-code__validate-error"
}, Dt = /* @__PURE__ */ R({
  __name: "AuthCode",
  props: {
    modelValue: {}
  },
  emits: ["validate", "update:modelValue", "resendCode"],
  setup(t, { emit: e }) {
    const a = e, i = H(), c = te(), {
      showValidateError: h,
      validateError: y
    } = c, s = S([]), T = S(!1), w = l(() => i == null ? void 0 : i.literals.getLiteral("Resend code")), L = () => {
      if (s.value.every((v) => v.value.length === 1)) {
        const v = s.value.map((o) => o.value).join("");
        a("update:modelValue", v), a("validate", v);
      }
    }, r = (d) => {
      if (s.value[d - 1].value.length === 1)
        if (d < 6) {
          const o = s.value[d];
          o && o.focus();
        } else
          s.value[d - 1].blur(), L();
    }, g = (d) => {
      var o;
      const v = ((o = d.clipboardData) == null ? void 0 : o.getData("text")) ?? "";
      if (v.length > 0) {
        const _ = v.slice(0, 6);
        s.value.forEach(async (P, $) => {
          P.value = _[$] ?? "", $ < s.value.length - 1 && (s.value[$ + 1].focus(), await Fe(), s.value[$ + 1].setSelectionRange(0, 1));
        }), s.value[s.value.length - 1].blur(), L();
      }
    }, n = () => {
      s.value.forEach((d) => {
        d.value = "";
      }), h.value = !1, a("update:modelValue", ""), a("resendCode");
    };
    return Y(() => {
      var d;
      T.value = !0, (d = s.value[0]) == null || d.focus();
    }), (d, v) => T.value ? (f(), b("div", At, [
      m("div", Mt, [
        (f(), b(O, null, Q(6, (o) => m("input", {
          tabindex: "0",
          ref_for: !0,
          ref_key: "inputRefs",
          ref: s,
          key: o,
          class: ce([
            "code-input",
            p(h) && "code-input--error"
          ]),
          maxlength: "1",
          type: "text",
          inputmode: "numeric",
          onFocus: v[0] || (v[0] = (_) => _.target.select()),
          onInput: (_) => r(o),
          onPaste: g,
          required: ""
        }, null, 42, Rt)), 64))
      ]),
      p(h) ? (f(), b("div", xt, V(p(y)), 1)) : Z("", !0),
      m("a", {
        href: "#",
        onClick: ve(n, ["prevent"])
      }, V(w.value), 1)
    ])) : Z("", !0);
  }
}), Ft = { class: "thn--tool-signin__heading" }, Ht = {
  role: "heading",
  "aria-level": "1"
}, qt = { class: "thn--tool-signin__form" }, Bt = { class: "thn--tool-signin__actions" }, It = ["data-full-width"], Kt = { class: "thn--tool-button__label" }, Et = { class: "thn--tool-signin__heading thn--tool-signin__heading--auth-code" }, zt = {
  role: "heading",
  "aria-level": "1"
}, Nt = /* @__PURE__ */ R({
  __name: "Signin",
  setup(t) {
    const e = H(), a = te(), {
      emailValue: i,
      buttonStyle: c,
      authCodeValue: h,
      buttonAppearance: y,
      isAuthCodeRequested: s,
      showValidateError: T,
      appearanceStyle: w,
      goToSignin: L,
      goToRegister: r,
      doLoginAction: g
    } = a, n = S(), d = S(!1), v = l(() => (e == null ? void 0 : e.handlers.buttonState) === le.Sending), o = l(() => e == null ? void 0 : e.literals.getLiteral("Sign in to your account")), _ = l(() => e == null ? void 0 : e.literals.getLiteral("Please, provide a valid e-mail")), P = l(() => e == null ? void 0 : e.literals.getLiteral("Your email")), $ = l(() => e == null ? void 0 : e.literals.getLiteral("Not registered yet?")), E = l(() => e == null ? void 0 : e.literals.getLiteral("Register")), z = l(() => e == null ? void 0 : e.literals.getLiteral("Sign in")), q = l(() => e == null ? void 0 : e.literals.getLiteral("Confirm your email")), I = l(() => e == null ? void 0 : e.literals.getLiteral("Enter the validation code sent to your email"));
    function x() {
      return n.value && n.value.validate() ? {
        action: U.Signin,
        emailAddress: i.value
      } : !1;
    }
    function u() {
      return {
        action: U.Resend
      };
    }
    function k() {
      var N;
      return ((N = h.value) == null ? void 0 : N.length) === 6 ? {
        action: U.Validation,
        code: h.value
      } : !1;
    }
    const D = () => {
      d.value = !0, g(x);
    }, oe = async () => {
      await g(u), s.value = !0;
    }, se = () => {
      g(k);
    }, ie = () => {
      s.value = !1, T.value = !1, d.value ? L() : r(), d.value = !1;
    };
    return (N, B) => {
      var W;
      return f(), b("div", j(N.$attrs, { class: "thn--tool-signin" }), [
        p(s) ? (f(), b(O, { key: 1 }, [
          M(Ct, { onGoBack: ie }, {
            default: Le(() => [
              He(V(p(i)), 1)
            ]),
            _: 1
          }),
          m("header", Et, [
            m("div", zt, V(q.value), 1),
            m("p", null, V(I.value), 1)
          ]),
          M(Dt, {
            modelValue: p(h),
            "onUpdate:modelValue": B[2] || (B[2] = (G) => de(h) ? h.value = G : null),
            onValidate: se,
            onResendCode: oe
          }, null, 8, ["modelValue"])
        ], 64)) : (f(), b(O, { key: 0 }, [
          m("header", Ft, [
            m("div", Ht, V(o.value), 1)
          ]),
          m("div", qt, [
            M(he, {
              class: "thn--tool-signin__input",
              ref_key: "emailRef",
              ref: n,
              type: "email",
              modelValue: p(i),
              "onUpdate:modelValue": B[0] || (B[0] = (G) => de(i) ? i.value = G : null),
              placeholder: P.value,
              "error-message": _.value,
              disabled: !!v.value,
              required: !0,
              style: A(p(w))
            }, null, 8, ["modelValue", "placeholder", "error-message", "disabled", "style"]),
            m("div", Bt, [
              m("div", {
                role: "button",
                tabindex: "0",
                class: "thn--tool-button",
                style: A(p(c)),
                "data-full-width": (W = p(y)) == null ? void 0 : W.fullWidth,
                onClick: D,
                onKeydown: pe(D, ["enter"])
              }, [
                B[3] || (B[3] = m("div", { class: "thn--tool-button__back" }, null, -1)),
                m("div", Kt, V(z.value), 1)
              ], 44, It),
              m("div", {
                class: "thn--tool-signin__signin",
                style: A(p(w))
              }, [
                m("span", null, V($.value), 1),
                m("a", {
                  href: "#",
                  onClick: B[1] || (B[1] = ve(
                    //@ts-ignore
                    (...G) => p(r) && p(r)(...G),
                    ["prevent", "stop"]
                  ))
                }, V(E.value), 1)
              ], 4)
            ])
          ])
        ], 64))
      ], 16);
    };
  }
}), Ot = { class: "thn--tool-login__success" }, Ut = { class: "thn--tool-login__success__header" }, Zt = { class: "thn--tool-login__success__hello" }, Yt = { class: "thn--tool-login__success__email" }, jt = /* @__PURE__ */ R({
  __name: "LoginSuccess",
  setup(t) {
    const e = H(), a = te(), {
      emailValue: i,
      appearanceStyle: c
    } = a, h = l(() => e == null ? void 0 : e.literals.getLiteral("Hello")), y = l(() => e == null ? void 0 : e.literals.getLiteral("Exclusive benefits unlocked!"));
    return (s, T) => (f(), b("div", Ot, [
      m("div", Ut, [
        m("p", Zt, V(h.value) + ", ", 1),
        m("p", Yt, V(p(i)), 1)
      ]),
      m("p", {
        class: "thn--tool-login__success__benefits",
        style: A(p(c))
      }, V(y.value), 5)
    ]));
  }
}), Wt = ["data-module-id"], Gt = { class: "thn--tool-login__container" }, Jt = /* @__PURE__ */ R({
  __name: "Login",
  props: {
    moduleProps: {}
  },
  setup(t) {
    const e = t, a = {
      [K.LoginRegister]: yt,
      [K.LoginSignin]: Nt,
      [K.LoginSuccess]: jt
    }, i = te(), {
      initModule: c,
      updateModule: h,
      currentStep: y
    } = i;
    return qe(() => e.moduleProps, () => {
      h(e.moduleProps);
    }), Y(() => {
      c(e.moduleProps);
    }), (s, T) => {
      var w;
      return f(), b("div", {
        class: "thn--tool-login",
        "data-module-id": (w = e.moduleProps) == null ? void 0 : w.id
      }, [
        m("div", Gt, [
          M(Be, {
            name: "fade",
            mode: "out-in"
          }, {
            default: Le(() => [
              (f(), me(Pe(a[p(y)])))
            ]),
            _: 1
          })
        ])
      ], 8, Wt);
    };
  }
}), Qt = ["can-animate"], Xt = ["state", "data-add-module", "data-vertical-center", "data-image-position"], da = /* @__PURE__ */ R({
  __name: "Steps",
  props: {
    steps: {},
    hasExtraSteps: {},
    maxHeight: {},
    toolKind: {},
    layoutKind: {},
    layout: {},
    imagePosition: {}
  },
  setup(t) {
    we((n) => ({
      "0a133e12": T.value
    }));
    const e = {
      [C.Heading]: Se,
      [C.Paragraph]: Se,
      [C.SavedSearch]: ke,
      [C.EmailCapture]: ke,
      [C.Button]: Ze,
      [C.Perks]: at,
      [C.Countdown]: rt,
      [C.Form]: dt,
      [C.Spacer]: mt,
      [C.Login]: Jt
    }, a = H(), i = t, c = S(), h = l(() => {
      var n;
      return (n = c.value) == null ? void 0 : n.querySelector(`.thn--tool-steps__step--${a == null ? void 0 : a.handlers.stepActive}`);
    }), y = l(() => Object.keys(i.steps)), { height: s } = Oe(h), T = l(() => i.toolKind === ye.Inliner ? "0" : "100%"), w = l(() => {
      let n = parseInt((a == null ? void 0 : a.styles.getCssVariableValue("--step-padding")) || "10", 10);
      n = i.layoutKind === J.LowerNotification ? n * 2 + 5 : n;
      let d = s.value + 2 * n;
      return i.maxHeight && (d = Math.min(i.maxHeight, d)), {
        height: i.layoutKind === J.SquareImage && i.toolKind !== ye.Inliner ? "100%" : be(d),
        overflowY: a != null && a.handlers.isFirstStep ? "auto" : "hidden"
      };
    }), L = l(() => {
      let n;
      return s.value < 320 ? n = s.value : s.value >= 320 && s.value < 450 ? n = s.value + s.value * 0.35 : s.value >= 450 && s.value < 650 ? n = s.value + s.value * 0.55 : n = s.value + s.value * 0.65, {
        height: be(n)
      };
    });
    function r(n) {
      return e[n] || "div";
    }
    function g(n) {
      switch (!0) {
        case (a == null ? void 0 : a.handlers.stepActive) === n:
          return ne.Active;
        case (a == null ? void 0 : a.handlers.stepPrevious) === n:
          return ne.Previous;
        default:
          return ne.Next;
      }
    }
    return Y(() => {
      Ye.value = c.value;
    }), (n, d) => {
      var v;
      return f(), b("div", {
        class: "thn--tool-steps",
        ref_key: "rootDom",
        ref: c,
        style: A(w.value),
        "can-animate": !((v = p(a)) != null && v.handlers.isFirstStep),
        "data-testid": "steps"
      }, [
        n.layoutKind === p(J).SquareImage && n.imagePosition === "top" ? (f(), b("div", {
          key: 0,
          class: "thn--tool-steps__container",
          style: A(L.value)
        }, null, 4)) : Z("", !0),
        (f(!0), b(O, null, Q(y.value, (o) => {
          var _;
          return f(), b("div", {
            class: ce(`thn--tool-steps__step thn--tool-steps__step--${o}`),
            state: g(o),
            key: o,
            "data-add-module": o === p(ae).Main && o === ((_ = p(a)) == null ? void 0 : _.handlers.stepActive),
            "data-vertical-center": n.layoutKind === p(J).SquareImage && o === "main",
            "data-image-position": n.imagePosition
          }, [
            (f(!0), b(O, null, Q(n.steps[o], (P, $) => (f(), me(Pe(r(P.moduleType)), j({
              class: "thn--tool-steps__step-component",
              key: $,
              "has-extra-steps": n.hasExtraSteps,
              layout: n.layout,
              ref_for: !0
            }, {
              moduleProps: P
            }), null, 16, ["has-extra-steps", "layout"]))), 128))
          ], 10, Xt);
        }), 128))
      ], 12, Qt);
    };
  }
});
export {
  ne as S,
  da as _
};
//# sourceMappingURL=Steps.vue_vue_type_style_index_0_lang.DnsnL9hF.js.map
